<template>
    <div>
        <div class="header_unit header_bg_blue">
            <div class="header_box">
                <div class="menu_left">
                    <router-link :to="{ name: 'top' ,
                    params: { brandPath: $route.params.brandPath}} ">TOPへ</router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_s"></p>
                    <p class="menu_center_tex_l">異常詳細</p>
                </div>
                <div class="menu_right">
                </div>
            </div>
        </div>
        <AlertList />
    </div>
</template>

<script>
    // @ is an alias to /src
    import AlertList from '@/app/components/AlertList.vue'

    export default {
        name: 'alertListIndex',
        components: {
            AlertList
        },
        props: {
            menuId: Number,
        }
    }
</script>
